module.exports = __webpack_public_path__ + "img/32.3c5446a4.jpg";